module.exports = __webpack_public_path__ + "static/img/whatApp.6474f70.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/common/whatApp.png
// module id = RAOG
// module chunks = 96